import { createAction } from '@reduxjs/toolkit';

export const requestCreateInitialSocialPerson = createAction('registration/createSocialInitialPerson');
export const requestRegister = createAction('registration/register');
export const requestCreateInitialPerson = createAction('registration/createInitialPerson');
export const requestKeycloakRegistration = createAction('registration/create/keycloak-user');
